import TimeStamp from "../../timeStamp";
import {SPIELER_FIELD_SETTINGS} from "../spieler/spielerFieldSettings";
//import SPIELER_CHANGE_HANDLER from "../spieler/spielerChangeHandler";
import SPIELER_MEMBERSHIP_HANDLER from "../spieler/spielerMembershipHandler";

export const SPIELER_ACTION_FIELD_SETTINGS = {
    id: {excel: 'id', app: 'id', type: 'string'},
    createdAt: {excel: 'Erstellt am', app: 'Erstellt am', type: 'date',
                formatValue: (dataItem) => {
                    return TimeStamp.getLocalDateAndTime(dataItem.createdAt, true);
                }},
    createdAtSortable: {excel: 'Erstellt am', app: 'Erstellt am', type: 'date',
        formatValue: (dataItem) => {
            return TimeStamp.getDateTextLocal(dataItem.createdAt) + ' ' + TimeStamp.getLocalTime(dataItem.createdAt, true);
        }},
    createdByName: {excel: 'Erstellt von', app: 'Erstellt von', type: 'string'},
    excel: {excel: 'excel', app: 'excel', type: 'excel'},
    actionType: {excel: 'Aktin', app: 'Aktion', type: 'string',
                formatValue: (dataItem) => {
                    switch (dataItem.actionType) {
                        case 'edit': return 'Änderung';
                        case 'passDuplikat': return 'Pass-Duplikat';
                        case 'bestaetigungen': return 'Bestätigungen';
                        case 'verlaengerung': return 'Pass-Verlängerung';
                        default: return dataItem.actionType.charAt(0).toUpperCase() + dataItem.actionType.slice(1);
                    }
                }},
    changes: {excel: 'Änderungen', app: 'Änderungen', type: 'string',
                formatValue: (dataItem) => {
                    let list = [];
                    dataItem.changes.forEach( (change) => {
                        let changeTemp = JSON.parse(JSON.stringify(change));
                        list.push(
                                SPIELER_FIELD_SETTINGS[changeTemp.field].app +
                                ": '" +
                                changeTemp.valueOld +
                                "'  -->  '" +
                                changeTemp.valueNew +
                                 "'")
                    });
                    return list.length > 0 ? list.join(', ') : '-';
                }},
    changesRaw:  {excel: 'Änderungen', app: 'Änderungen', type: 'string',
                formatValue: (dataItem) => {
                    let list = [];
                    dataItem.changes.forEach( (change) => {
                        let itemNew = JSON.parse(JSON.stringify(change));
                        //console.log ("itemNew", itemNew);
                        if ( itemNew.field !== 'Foto' ) {
                            itemNew.field = SPIELER_FIELD_SETTINGS[itemNew.field].app;
                        }

                        list.push(itemNew);
                    });
                    return list;
                }},
    comment: {excel: 'Bemerkungen', app: 'Bemerkungen', type: 'string'},
    processedByName: {excel: 'Verarbeitet von', app: 'Verarbeitet von', type: 'string'},
    processedAt: {excel: 'Verarbeitet am', app: 'Verarbeitet am', type: 'string'},
    processed: {excel: 'Erledigt', app: 'Erledigt', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.processedAt ?
                        dataItem.processedByName + ', ' +
                        TimeStamp.getLocalDateAndTime( dataItem.processedAt, true) :
                        'Automatisch bestätigt, ' +
                        TimeStamp.getLocalDateAndTime( dataItem.createdAt, true);
                }},
    lvNrForNew: { excel: 'LV Nummer', app: 'LV-Nr.', type: 'integer',
                formatValue: (dataItem) => {
                    return SPIELER_MEMBERSHIP_HANDLER.getLVFromPendingMembership(dataItem);
                }},
    vereinsNrForNew: { excel: 'Vereins-nummer', app: 'VereinsNr.', type: 'integer',
                formatValue: (dataItem) => {
                    return SPIELER_MEMBERSHIP_HANDLER.getVereinNrFromPendingMembership(dataItem);
                }},
    vereinsName: { excel: 'Vereinsname', app: 'VereinsName', type: 'text'},
    spielerFull: {excel: 'Person', app: 'Pass, Person (Nat.), Verein', type: 'Person',
                formatValue: (dataItem) => {
                    const nat = dataItem.spieler.nationalitaet ? ' (' + dataItem.spieler.nationalitaet + ')' : ''
                    return dataItem.spieler.passNr +
                        ', ' + dataItem.spieler.nachname + ' ' + dataItem.spieler.vorname + nat + ', ' +dataItem.status_lvVerein;
                }},
    vonLVNr: { excel: 'von LV-Nummer', app: 'von LV-Nummer', type: 'integer',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'lvNr' );
                    return changeItem ? changeItem.valueOld : '';
                }},
    status_lvNr: { excel: 'LV-Nummer', app: 'LV-Nr.', type: 'integer' },
    passNr: { excel: 'Pass Nummer', app: 'Passnr.', childOf: 'spieler', type: 'integer',
                formatValue: (dataItem) => {
                    return dataItem.spieler.passNr ? dataItem.spieler.passNr.substr(2) : dataItem.spieler.passNr;
                }},
    passNrFull: { excel: 'Pass Nr.:  6stell.', app: 'Pass Nr.:  6stell.', childOf: 'spieler', type: 'integer',
                formatValue: (dataItem) => {
                    return dataItem.spieler.passNr;
                }},
    /*passNr: { excel: 'Pass Nummer', app: 'Passnr.', childOf: 'spieler', type: 'integer',
        formatValue: (dataItem) => {
            console.log ("!!!!!!!!!!!!!!!!!!!! dataItem:", dataItem.spieler);
            let passNr = SPIELER_MEMBERSHIP_HANDLER.getLastRegularPassNr(dataItem.spieler.memberships);
            return passNr ? passNr.substr(2) : passNr;
        }},
    passNrFull: { excel: 'Pass Nr.:  6stell.', app: 'Pass Nr.:  6stell.', childOf: 'spieler', type: 'integer',
        formatValue: (dataItem) => {
            console.log ("!!!!!!!!!!!!!!!!!!!! dataItem:", dataItem.spieler);
            return SPIELER_MEMBERSHIP_HANDLER.getLastRegularPassNr(dataItem.spieler.memberships);
        }},*/
    titel: { excel: 'Titel', app: 'Titel', childOf: 'private', type: 'string'},
    nachname: { excel: 'Familienname', app: 'Nachname', childOf: 'spieler', type: 'string'},
    vorname: { excel: 'Vorname', app: 'Vorname', childOf: 'spieler', type: 'string'},
    geschlecht: { excel: 'Geschlecht', app: 'Geschlecht', childOf: 'spieler_temp', type: 'string'},
    strasse: { excel: 'Strasse', app: 'Strasse', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.strasse;
                }},
    plz: { excel: 'PLZ', app: 'PLZ', childOf: 'private', type: 'integer',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.plz;
                }},
    ort: { excel: 'Ort', app: 'Ort', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.ort;
                }},
    telefon: { excel: 'Telefon', app: 'Telefon', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.telefon;
                }},
    mobilTelefon: { excel: 'Mobil Tel.:', app: 'Mobil Tel.:', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.mobilTelefon;
                }},
    passGueltigAb: { excel: 'Datum der Verlängerung', app: 'Verlängerung ab', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.actionDate;
                }},
    geburtsdatum: {   excel: 'Geburtsdatum', app: 'Geburtsdatum', childOf: 'private', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.geburtsdatum;
                }},
    geburtsort: {   excel: 'Geburtsort', app: 'Geburtsort', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.geburtsort;
                }},
    gebDatum: {   excel: 'Geb.Datum', app: 'Geburtsdatum', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.geburtsdatum;
                }},
    nationalitaet: {excel: 'Nationalität', app: 'Nationalität', childOf: 'private', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler_temp.private.nationalitaet;
                }},
    nationalitaetSpieler: {excel: 'Nationalität', app: 'Nationalität', childOf: 'spieler', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler.nationalitaet;
                }},
    ade: { excel: 'ADE', app: 'ADE', type: 'date',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'ade' );
                    return changeItem ? changeItem.valueNew : '';
                }},
    dsv: { excel: 'DSV', app: 'DSV', type: 'date',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'dsv' );
                    return changeItem ? changeItem.valueNew : '';
                }},
    attest: { excel: 'Ärztliches Attest', app: 'Ärztliches Attest', type: 'date',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'attest' );
                    return changeItem ? changeItem.valueNew : '';
                }},
    neueVereinsNr: { excel: 'Vereins-nummer', app: 'Vereins-nummer', type: 'integer',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'vereinsNr' );
                    return changeItem ? changeItem.valueNew : '';
                }},
    neueVereinsNrLv: { excel: 'Vereins-Nummer', app: 'Vereins-nummer', type: 'integer',
                formatValue: (dataItem) => {
                    let changeItem = dataItem.changes.find( item => item.field === 'vereinsNr' );
                    return changeItem ? changeItem.valueNew : '';
                }},
    ummeldeDatum: { excel: 'Ummelde Datum', app: 'Ummeldedatum', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.actionDate;
                }},
    abmeldeTag: { excel: 'Abmeldetag', app: 'Abmeldetag', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.actionDate;
                }},
    anmeldeDatum: { excel: 'Anmelde Datum', app: 'Anmelde Datum', type: 'date',
                formatValue: (dataItem) => {
                    return dataItem.actionDate;
                }},
    vereinsNr: { excel: 'Vereins-nummer', app: 'Vereinsnr.', type: 'integer',
                formatValue: (dataItem) => {
                    return dataItem.status_lvVerein.substring(2);
                }},
    vereinsNrFull: { excel: 'Vereins-nummer', app: 'Vereinsnr.', type: 'integer',
                formatValue: (dataItem) => {
                    return dataItem.status_lvVerein;
                }},
    vereinPass: {excel: 'Verein/Pass', app: 'Verein/Pass', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.status_lvVerein.substr(2) + " / " + dataItem.spieler.passNr;
                }},
    bilddateiNeu: {excel: 'Bilddatei', app: 'Bilddatei', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.vorname + "_" + dataItem.nachname + '.jpg';
                }},
    bilddatei: {excel: 'Bilddatei', app: 'Bilddatei', type: 'string',
                formatValue: (dataItem) => {
                    return dataItem.spieler.vorname + "_" + dataItem.spieler.nachname + '.jpg';
                }},
    bildformat: {excel: 'Bild-Format', app: 'Bild-Format', type: 'string',
                formatValue: () => {
                    return 'jpg';
                }},
    leer: {excel: '', app: '', type: 'string',
                formatValue: () => {
                    return '';
                }},
};
